import { useMemo } from 'react';
import { DashBoardValue } from 'features/dashBoard/hooks';
import { DashBoardItemOption } from 'features/dashBoard/types';
import { GraphOptions, getAxisDef, getValueDef } from '../../common'

import {
  Sort as SortIcon
 } from '@mui/icons-material';

 import { TargetListResult } from "interface/search/targetList"

export const SingleBarGraphOptions: GraphOptions[][] = [
  [
    {
      id: 'axis',
      type: 'axis',
      label: '軸',
      suffix: 'ごとの'
    }, {
      id: 'value',
      type: 'value',
      label: '値'
    }, {
      id: 'formula',
      type: 'choice',
      prefix: 'の',
      label: '集計式',
      data: [
        { label: '合計', value: 'sum', showOnTitle: false },
        { label: '平均', value: 'ave' },
        { label: '最大', value: 'max' },
        { label: '最小', value: 'min' },
      ],
      default: 'sum',
    },
  ],
  [
    {
      id: 'sort',
      type: 'check',
      label: '並び替え',
      default: 'false',
      toolBtn: <SortIcon fontSize="small"/>
    }
  ]
]
type useSingleBarGraphOptionProps<T> = {
  dashBoard: DashBoardValue<T>
  options?: DashBoardItemOption[]
  targetList?: TargetListResult
}
export const useSingleBarGraphOption = <T,>({
  dashBoard: { configure, globalAxisKey },
  options,
  targetList
}: useSingleBarGraphOptionProps<T>) => useMemo(
  () => ({
    configure, targetList,
    axisDef: getAxisDef(configure, options, 'axis', globalAxisKey, targetList),
    valueDef: getValueDef(configure, options, 'value', targetList),
    formula: options?.find((opt) => opt.id === 'formula')?.value,
    sort: options?.find((opt) => opt.id === 'sort')?.value === 'true'
  }),
  [options, configure, globalAxisKey, targetList]
)
